export const makeSaveAddressData = ({
  data: validatedAddress,
  planningData,
  housePricesData,
  searchHistory,
  currentUser,
  lastSalePrice,
}) => {
  if (!validatedAddress) return;

  const searchId =
    Array.isArray(searchHistory) && searchHistory.length > 0 && searchHistory?.[0]?.id
      ? searchHistory?.[0]?.id
      : null;

  let streetNumber = validatedAddress.street_number;
  if (!streetNumber && validatedAddress.address) {
    const match = validatedAddress.address.match(/^(\d+[A-Za-z]?)\s/);
    if (match) {
      streetNumber = match[1];
    }
  }

  const annualGrowthRate = housePricesData?.annualGrowth;
  const actualPropertyType =
    validatedAddress.property_type || validatedAddress.propertyType || 'buy';

  return {
    address: validatedAddress.address,
    postcode: validatedAddress.postcode,
    flat_number: validatedAddress.flat_number,
    search_type: currentUser ? currentUser.subscription_type || 'free' : 'free',
    property_type: actualPropertyType,
    lat: validatedAddress.lat,
    lng: validatedAddress.lng,
    apiData: {
      housePrices: housePricesData,
      planning: planningData,
      lastSalePrice,
    },
    search_timestamp: new Date().toISOString(),
    formatted_address: validatedAddress.address,
    timestamp: new Date().toISOString(),
    street_number: streetNumber || validatedAddress.street_number || '',
    street: validatedAddress.street || '',
    id: searchId,
    annual_growth_rate: annualGrowthRate?.toFixed(2),
    planning_success_rate:
      planningData?.applications?.[0]?.authority_stats?.decisions_granted_percentage ?? null,
  };
};
